"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        alignItems: 'center',
        display: 'flex'
    },
    left: {
        justifyContent: 'flex-start'
    },
    center: {
        justifyContent: 'center'
    },
    right: {
        justifyContent: 'flex-end'
    }
}); });
exports["default"] = (function (props) {
    var _a = props.position, position = _a === void 0 ? 'center' : _a, _b = props.size, size = _b === void 0 ? 40 : _b;
    var classes = useStyles();
    return (react_1["default"].createElement("div", { className: [classes.root, classes[position]].join(' '), role: "progressbar", "aria-label": "Loading" },
        react_1["default"].createElement(CircularProgress_1["default"], { size: size })));
});
